// Public ingestion key for the existing InkHammy project; override per deployment if needed.
export const defaultGlitchTipDSN = 'https://f56a0741637042cea2b178770e9333cd@glitchtip.mindcrafters.group/19';

export const defaultRelease = 'InkHammy-api@1.0.0';
